import { format, isToday, isYesterday } from 'date-fns'

import { TimeRangePreset } from '~/user-stats/types/user-stats.types'
import { getDateRangeForPreset } from '~/user-stats/utility/date.utils'

import { DayOfMonth } from '../types/common.types'

export function getFilterDates(option: string): Date[] | undefined[] {
  switch (option) {
    case 'all-time':
      return getDateRangeForPreset(TimeRangePreset.ALL_TIME)
    case 'last-7-days':
      return getDateRangeForPreset(TimeRangePreset.LAST_7_DAYS) as Date[]
    case 'last-30-days':
      return getDateRangeForPreset(TimeRangePreset.LAST_30_DAYS) as Date[]
    case 'last-90-days':
      return getDateRangeForPreset(TimeRangePreset.LAST_90_DAYS) as Date[]
    case 'last-year':
      return getDateRangeForPreset(TimeRangePreset.LAST_YEAR) as Date[]
    default:
      return getDateRangeForPreset(TimeRangePreset.LAST_30_DAYS) as Date[]
  }
}

export function getLastVisitDate(dateStr: string): string {
  const date = new Date(dateStr)
  const today = isToday(date)
  const yesterday = isYesterday(date)

  if (today) {
    return DayOfMonth.TODAY
  } else if (yesterday) {
    return DayOfMonth.YESTERDAY
  } else {
    return format(date, 'do MMMM yyyy')
  }
}
